import React from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import { Image } from "semantic-ui-react";
import { Link } from "react-router-dom";

const AccountModal = ({ isOpen, event }) => {
  return (
    <MDBContainer>
      <MDBModal isOpen={isOpen} toggle={() => event()} centered>
        <MDBModalHeader
          className="modal-container-header"
          // toggle={() => event()}
          style={{
            display: "flex",
            flexGrow: 1,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <Image
              className="modal-image-header"
              src="./assets/logo-white.png"
              style={{
                width: 150,
                height: "auto",
              }}
            />
          </div>
        </MDBModalHeader>
        <MDBModalBody>
          <div>
            <div style={{ paddingBottom: 20 }}>
              <h4 style={{ textAlign: "center" }}>
                Disfruta de todos los beneficios que trae ser miembro de La
                Floristería Honduras.
              </h4>
            </div>
            <p style={{ textAlign: "center" }}>
              Si ya eres parte de nosotros, inicia sesión y si todavía no lo
              eres, puedes registrarte.
            </p>

            <p style={{ textAlign: "center", fontSize: 10 }}>
              ** Recuerda que siempre puedes realizar tu pedido sin tener que
              registarte.
            </p>
          </div>
        </MDBModalBody>
        <MDBModalFooter style={{ display: "flex", justifyContent: "center" }}>
          <Link to="/login">
            <MDBBtn color="dark">Iniciar sesión</MDBBtn>
          </Link>
          <Link to="/signup">
            <MDBBtn color="blue">Registrarse</MDBBtn>
          </Link>

          <MDBBtn color="green" onClick={() => event()}>
            Continuar
          </MDBBtn>
        </MDBModalFooter>
      </MDBModal>
    </MDBContainer>
  );
};

export default AccountModal;
